// components/modal/ModalPortals.js
import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { useSelector } from "react-redux";
import { selectIsMainModalOpen, selectIsSubModalOpen } from "../../../redux/modal-slice/modalSlice";
import { modalComponentStore } from "./modalComponentStore";

export const MainModalPortal = () => {
  const isOpen = useSelector(selectIsMainModalOpen);
  const portalRef = useRef(null);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    if (document) {
      const dom = document.querySelector("#ROOT_MODAL");
      portalRef.current = dom;
    }
  }, []);


  if (portalRef.current && mounted && isOpen) {
    const component = modalComponentStore.getMainComponent();
    if (component) {
      return createPortal(component, portalRef.current);
    }
  }
  return null;
};

export const SubModalPortal = () => {
  const isOpen = useSelector(selectIsSubModalOpen);
  const portalRef = useRef(null);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    if (document) {
      const dom = document.querySelector("#SUB_MODAL");
      portalRef.current = dom;
    }
  }, []);


  if (portalRef.current && mounted && isOpen) {
    const component = modalComponentStore.getSubComponent();
    if (component) {
      return createPortal(component, portalRef.current);
    }
  }
  return null;
};
